import { HttpErrorResponse } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import {
  ChangePasswordCommand,
  ChangePasswordService,
} from "app/api/sidc-services/identity";
import { MustMatchValidator } from "app/common/ui/validators/mustmatch.validator";
import { PasswordValidator } from "app/common/ui/validators/password.validator";
import { BlockUI, NgBlockUI } from "ng-block-ui";
import { ToastrService } from "ngx-toastr";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import Swal from "sweetalert2";

@Component({
  selector: "app-change-password",
  templateUrl: "./change-password.component.html",
  styleUrls: ["./change-password.component.scss"],
})
export class ChangePasswordComponent implements OnInit {
  public contentHeader: object;
  public changePasswordForm: FormGroup;
  public submitted = false;
  public currentUserName: string = null;
  public isOldPasswordHidden: boolean;
  public isNewPasswordHidden: boolean;
  public isConfirmPasswordHidden: boolean;
  public changePasswordCommand: ChangePasswordCommand;

  private unsubscribeAll: Subject<any>;
  @BlockUI() blockUI: NgBlockUI;

  constructor(
    private toastr: ToastrService,
    private formBuilder: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private changePasswordService: ChangePasswordService,
    private router: Router
  ) {
    this.unsubscribeAll = new Subject();
  }

  ngOnInit(): void {
    this.currentUserName = this.activatedRoute.snapshot.params["id"];

    this.contentHeader = {
      headerTitle: "Change Password",
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/dashboard/",
          },
          {
            name: "Change Password",
            isLink: false,
          },
        ],
      },
    };

    this.changePasswordForm = this.formBuilder.group(
      {
        username: this.currentUserName,
        currentPassword: ["", Validators.required],
        password: ["", [Validators.required, PasswordValidator.strong]],
        confirmPassword: ["", Validators.required],
      },
      { validator: [MustMatchValidator("password", "confirmPassword")] }
    );
  }

  get f() {
    return this.changePasswordForm.controls;
  }

  hideUnhideOldPassword() {
    this.isOldPasswordHidden = !this.isOldPasswordHidden;
  }

  hideUnhideNewPassword() {
    this.isNewPasswordHidden = !this.isNewPasswordHidden;
  }
  hideUnhideConfirmPassword() {
    this.isConfirmPasswordHidden = !this.isConfirmPasswordHidden;
  }

  onSubmit() {
    this.submitted = true;

    if (this.changePasswordForm.invalid) {
      return;
    }

    this.changePasswordCommand = this.changePasswordForm.getRawValue();
    console.log("Input: ", this.changePasswordCommand);

    Swal.fire({
      title: "Are you sure?",
      text: "Your password will be changed.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#7367F0",
      cancelButtonColor: "#E42728",
      confirmButtonText: "Yes",
      customClass: {
        confirmButton: "btn btn-primary",
        cancelButton: "btn btn-danger ml-1",
      },
    }).then((result) => {
      if (result.value) {
        this.blockUI.start();
        this.changePasswordService
          .apiChangepasswordChangePasswordPost(this.changePasswordCommand)
          .pipe(takeUntil(this.unsubscribeAll))
          .subscribe(
            (response) => {
              this.blockUI.stop();
              Swal.fire({
                title: "Great!",
                text: "Password has been changed successfully.",
                icon: "success",
                confirmButtonColor: "#7367F0",
                confirmButtonText: "Ok",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
              });
              this.router.navigate(["/application"]);
            },
            (httpError: HttpErrorResponse) => {
              this.blockUI.stop();
              this.toastr.error("", httpError.error.Message, {
                timeOut: 3000,
                positionClass: "toast-bottom-center",
                toastClass: "toast ngx-toastr",
              });
            }
          );
      }
    });
  }
}
